/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Language } from './Language';
import {
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
    LanguageToJSONTyped,
} from './Language';
import type { SapUserDataResponse } from './SapUserDataResponse';
import {
    SapUserDataResponseFromJSON,
    SapUserDataResponseFromJSONTyped,
    SapUserDataResponseToJSON,
    SapUserDataResponseToJSONTyped,
} from './SapUserDataResponse';
import type { UserKrrInfoResponse } from './UserKrrInfoResponse';
import {
    UserKrrInfoResponseFromJSON,
    UserKrrInfoResponseFromJSONTyped,
    UserKrrInfoResponseToJSON,
    UserKrrInfoResponseToJSONTyped,
} from './UserKrrInfoResponse';
import type { UserOrganizationGroupResponse } from './UserOrganizationGroupResponse';
import {
    UserOrganizationGroupResponseFromJSON,
    UserOrganizationGroupResponseFromJSONTyped,
    UserOrganizationGroupResponseToJSON,
    UserOrganizationGroupResponseToJSONTyped,
} from './UserOrganizationGroupResponse';
import type { UserIdentityOrigin } from './UserIdentityOrigin';
import {
    UserIdentityOriginFromJSON,
    UserIdentityOriginFromJSONTyped,
    UserIdentityOriginToJSON,
    UserIdentityOriginToJSONTyped,
} from './UserIdentityOrigin';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface UserProfileResponse
 */
export interface UserProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    surName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    telefonNr?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    mfaPhoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    employer?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof UserProfileResponse
     */
    userType?: UserType;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileResponse
     */
    isValidated?: boolean;
    /**
     * 
     * @type {UserIdentityOrigin}
     * @memberof UserProfileResponse
     */
    identityOrigin?: UserIdentityOrigin;
    /**
     * 
     * @type {Language}
     * @memberof UserProfileResponse
     */
    preferredLanguage?: Language;
    /**
     * 
     * @type {SapUserDataResponse}
     * @memberof UserProfileResponse
     */
    sapUserData?: SapUserDataResponse;
    /**
     * 
     * @type {UserKrrInfoResponse}
     * @memberof UserProfileResponse
     */
    userKrrInfo?: UserKrrInfoResponse;
    /**
     * 
     * @type {UserOrganizationGroupResponse}
     * @memberof UserProfileResponse
     */
    statsforvalterenOrganizationGroup?: UserOrganizationGroupResponse;
}



/**
 * Check if a given object implements the UserProfileResponse interface.
 */
export function instanceOfUserProfileResponse(value: object): value is UserProfileResponse {
    return true;
}

export function UserProfileResponseFromJSON(json: any): UserProfileResponse {
    return UserProfileResponseFromJSONTyped(json, false);
}

export function UserProfileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProfileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'surName': json['surName'] === undefined ? undefined : json['surName'] === null ? null : json['surName'],
        'telefonNr': json['telefonNr'] === undefined ? undefined : json['telefonNr'] === null ? null : json['telefonNr'],
        'mfaPhoneNumber': json['mfaPhoneNumber'] === undefined ? undefined : json['mfaPhoneNumber'] === null ? null : json['mfaPhoneNumber'],
        'employer': json['employer'] === undefined ? undefined : json['employer'] === null ? null : json['employer'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'isValidated': json['isValidated'] == null ? undefined : json['isValidated'],
        'identityOrigin': json['identityOrigin'] == null ? undefined : UserIdentityOriginFromJSON(json['identityOrigin']),
        'preferredLanguage': json['preferredLanguage'] == null ? undefined : LanguageFromJSON(json['preferredLanguage']),
        'sapUserData': json['sapUserData'] == null ? undefined : SapUserDataResponseFromJSON(json['sapUserData']),
        'userKrrInfo': json['userKrrInfo'] == null ? undefined : UserKrrInfoResponseFromJSON(json['userKrrInfo']),
        'statsforvalterenOrganizationGroup': json['statsforvalterenOrganizationGroup'] == null ? undefined : UserOrganizationGroupResponseFromJSON(json['statsforvalterenOrganizationGroup']),
    };
}

export function UserProfileResponseToJSON(json: any): UserProfileResponse {
    return UserProfileResponseToJSONTyped(json, false);
}

export function UserProfileResponseToJSONTyped(value?: UserProfileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'email': value['email'],
        'name': value['name'],
        'firstName': value['firstName'],
        'surName': value['surName'],
        'telefonNr': value['telefonNr'],
        'mfaPhoneNumber': value['mfaPhoneNumber'],
        'employer': value['employer'],
        'userType': UserTypeToJSON(value['userType']),
        'isValidated': value['isValidated'],
        'identityOrigin': UserIdentityOriginToJSON(value['identityOrigin']),
        'preferredLanguage': LanguageToJSON(value['preferredLanguage']),
        'sapUserData': SapUserDataResponseToJSON(value['sapUserData']),
        'userKrrInfo': UserKrrInfoResponseToJSON(value['userKrrInfo']),
        'statsforvalterenOrganizationGroup': UserOrganizationGroupResponseToJSON(value['statsforvalterenOrganizationGroup']),
    };
}

